import { render, staticRenderFns } from "./IvfIncome.vue?vue&type=template&id=672ab87f&scoped=true"
import script from "./IvfIncome.vue?vue&type=script&lang=js"
export * from "./IvfIncome.vue?vue&type=script&lang=js"
import style0 from "./IvfIncome.vue?vue&type=style&index=0&id=672ab87f&prod&scoped=true&lang=css"
import style1 from "./IvfIncome.vue?vue&type=style&index=1&id=672ab87f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672ab87f",
  null
  
)

export default component.exports